import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  ${({ grid }) =>
    grid
      ? css`
          height: 440px;
          @media screen and (max-width: 782px) {
            height: 55rem;
          }
        `
      : css`
          height: 55rem;
        `};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 2.3rem;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.3);
  padding: 20px;

  @media screen and (max-width: 768px) {
    padding: 15px;
  }
  p {
    font-size: 15px;
    color: #071242;
    text-align: start;
    width: 100%;
    font-weight: bold;
  }
`;

export const ErrorContainer = styled.div`
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  p{
    color: #777;
    text-align: center;
  }
`
